const greeting = {
  firstName: "Vinay",
  lastName: "Guda",
  initial: "G",
  title: "I'm Vinay Guda",
  subTitle: "A passionate full-stack Software Engineer having experience in developing Web applications with Java / JavaScript / React.js / Angular.js / Node.js and some other cool libraries and frameworks.",
  resumeLink: "https://flowcv.com/resume/439lsj6sr4",
  profilePicture: "https://lh3.googleusercontent.com/fife/AAWUweXh2QdTtLnNbqqrnoYU3LT4P6MFkGDiEY6b4opy7_g7p7H-F9MCZiKNxd5qK72J_oPu0DSUiYyfV4Ml1k7VfEu5OjVIALqywNM8cpgRb2996B0_6gAssd15hmimASqlqOcPe7HK6xkIblX67iBEMxDt7NGlPcbbD6dQE50z4C9NRHMsOFJQvtPFHfJIEwU8ZgCZ4CGgxhNuZDiXxShlq_Pz-DhLWsD4N69dzOtdH817CN4mhzegiC6xXVUh4Rdp5cebBVd-GJF-QY4qkpgS7KeBCjBTGi9HMaINsMSDvFI4yxq2d6mO503DXd8Dmzr4HF3aMoprMGbfPMzG4xQCW-iCKLg5UmMhIOuSBMIJlNCkg9g3QZT6uCX9MYGjMBfAOzbPO3199hFdX-G9nDSb68H68aopRZsV0LhB_b9QKalKI9gUEGjxGeSLjt3Cs0853DLRo6yDq1hTwJ_rErQW6O_OMPOpbdMjkTinKLsJZyenVfnFQ60kv7JjUISRu4JkrsJzUfi_vFzIJh7wUm5veTD1WdTS4aTUX_3hbKBgNzwzQS5SgiEJZdtJZJI1_eRPfuO2kNnCZjnE2iE3Yz3gBjt9AcisS6HvzZ8TU5SA2E7L6kBLL8ILnM9FSHYh8UprAJt8Z3xhcLUkZCqn9zHcZTaNgi54cTXCWKtfMqEccPYgictz79aDzZId77omvAI0b2Kwj0yqH_X1RHoAYflPH0EJhfFlkPjnqg=w1680-h971-ft"
};

// Your Social Media Link

const socialMediaLinks = {
  github: "https://github.com/gudavinay",
  linkedin: "https://www.linkedin.com/in/vinayguda/",
  gmail: "vinayguda05@gmail.com",
};

// Your Skills Section

const skillsSection = {
  title: "What i do 👨‍💻",
  subTitle: "⚡ Experienced full-stack developer who wants to create a positive impact on people's lives with technology.",
  subsubTitle: "⚡ and here's what I am good at 👇",
  skills: [
    "⚡ I build scalable, maintainable software with clean code and design systems that are robust and resilient by incorportaing all Software design principles",
    "⚡ Creative thinker always looking to simplify things for myself and my team",
    "⚡ Proven track record of delivering feature releases while meeting deadlines",
  ],
  softwareSkills: [
    {
      skillName: "JAVA",
      fontAwesomeClassname: " fab fa-java"
    },
    {
      skillName: "C / C++",
      fontAwesomeClassname: "fas fa-copyright"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "React.js",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Android Studio",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Github",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "JIRA",
      fontAwesomeClassname: "fab fa-jira"
    },

  ]
};


// Your top 3 work experiences

const workExperiences = {
  viewExperiences: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "SDE Intern",
      company: "Amazon",
      companylogo: require("./assets/images/Amazon.jpeg"),
      date: "May 2022 – Aug 2022 (3m)",
      desc: "Architected, implemented and delivered a solution for AmazonLink team to onboard new customers ",
      descBullets: [
        "Designed and implemented a cost-effective solution to automate onboarding of internal business users to SEDI platform .",
        "Optimized for scalability and consistency using AWS Constructs such as SNS, SQS, and Fargate.",
        "Managed to reduce the KTLO overhead and minimize High Severity Incidents on the AmazonLink team.",
        "Handled async nature of communication between my team and other teams using SNS and Fargate",
      ]
    },
    {
      role: "Graduate Teaching Assistant",
      company: "San Jose State University",
      companylogo: require("./assets/images/SJSU.jpeg"),
      date: "Aug 2021 – May 2022 (10m)",
      desc: "Worked as a TA for 2 semesters for the most demanding course in SJSU for Software Engineering students",
      descBullets: [
        "Assisted Prof. Simon Shim in tutoring a graduate-level course (CMPE-273 Enterprise Distributed Systems).",
        "Devised demos for full-stack web development in react, cloud deployment, load balancing, and domain-driven design.",
        "Designed labs and assignments and graded 80+ students' labs, assignments, and projects for two semesters.",
      ]
    },
    {
      role: "Software Development Intern",
      company: "eDiligence AI",
      companylogo: require("./assets/images/eDiligence.jpeg"),
      date: "Feb 2021 – May 2021 (4m)",
      desc: "Working as a full-stack engineer for a professor in Computer Engineering Department at SJSU",
      descBullets: [
        "Improved customer experience by designing an insightful and detailed drill-down view of data to gain more insights and by designing customizable widgets.",
        "Operated on advanced React.js concepts such as hooks and theming.",
        // "Coordinated with the development team to design an insightful, detailed drill-down view of data and customize widgets on customer-facing UI. Operated on advanced react concepts such as theming, hooks, functional components.",
      ]
    },
    {
      role: "Full Stack Software Developer",
      company: "Development Bank of Singapore",
      companylogo: require("./assets/images/dbs.jpeg"),
      date: "Jul 2018 – Dec 2020 (2.5y)",
      desc: "Worked on Angular(JS,4,5,8), NodeJS, JAVA, Spring, GIT, MySQL, JIRA, Apache Maven.",
      descBullets: [
        "Followed Agile model for developing and testing at unit level, system integration level, and enterprise applications.",
        "Acted as subject matter expert for a module and managed its req gathering, development, testing, deployment phases.",
        "Consistently delivered multiple projects with zero down time deployment and very minimal bugs.",
        "Improved efficiency and reviewed potential security breaches by fixing 3000+ SonarQube bugs through refactoring.",
        "Handled 40+ servers of Prod, Dev, SIT, UAT environments for deployment and maintenance.",
        "Collaborated with quality assurance (QA) team to improve most frequently affected areas after each deployment.",
        "Went out of the way to fix organization level framework bugs in shared components.",
        "Worked in an Agile environment for designing, developing, testing at the unit and system integration level, and enterprise applications. Used Spring Framework for implementing MVC architecture, the configuration of application components, object lifecycle management, and dependency injection.",
        // "Implemented Core Java concepts such as OOP Concepts, Collections Framework, Exception Handling, I/O System, Multi-Threading, and JDBC. Created Angular services, controllers and built models for two-way data binding.",
        "Trained and mentored 10+ new team members on the development process, application details and workflow."
      ]
    },
    {
      role: "Research Intern",
      company: "Indian Institute of Chemical Technology",
      companylogo: require("./assets/images/iict.jpeg"),
      date: "Nov 2017 – May 2018 (7m)",
      desc: "Full-stack development in Django-Python, PostgreSQL",
      descBullets: [
        "Developed a molecular database to store physical and chemical properties of samples submitted for record-keeping and a portal to allow authorized users to upload molecules, search existing ones and update users about the latest changes.",
        "The web application was built using PostgreSQL and Django to satisfy the above requirement. An open-source RDBMS data cartridge, called Bingo, was used to store and operate on molecular representations in the database. Additionally, Indigo toolkit was used to generate 2D coordinates of SMILES IDs, and Kekule.js to render these 2D coordinates onto the browser.",
        "Replaced legacy software with new portal built with open-source technologies and saved the institute $10,000/year."
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

// const openSource = {
//   githubConvertedToken: "xxxxx",
//   githubUserName: "gudavinay", // Change to your github username to view your profile in Contact Section.
//   showGithubProfile :"true" // Set true or false to show Contact profile using Github, defaults to false 
// };

const githubProjects = [
  {
    "name": "ProTrader (Social Trading Platform)",
    "description": "Unique and engaging platform for stock traders to connect, learn, and share trading strategies. Used real-time stock data to create a realistic and engaging user learning experience.",
    "forkCount": 1,
    "url": "https://github.com/gudavinay/SocialTradingPlatform-ProTrader",
    "diskUsage": 7503,
    "stargazerCount": 2,
    "primaryLanguage": {
      "name": "JavaScript",
      "color": "#f1e05a",
      "__typename": "Language"
    },
    "video": "https://youtu.be/v8Nmax12rcU"
  },
  {
    "name": "Google-stock-realtime",
    "description": "Real-time Stock data API for capturing quotes from Google Finance. Supports 1. Stock Overview 2. Last Price 3. Last Price for multiple stocks",
    "forkCount": 0,
    "url": "https://github.com/gudavinay/google-stock-realtime",
    "diskUsage": 255,
    "stargazerCount": 0,
    "primaryLanguage": {
      "name": "JavaScript",
      "color": "#f1e05a",
      "__typename": "Language"
    },
    "video": "https://www.npmjs.com/package/google-stock-realtime"
  },
  {
    "name": "Reddit",
    "description": "Reddit replica using MERN stack. Key features: Multiple database- MySQL & MongoDB ,Redis Cache,Apache Kafka, Passport JWT Auth.",
    "forkCount": 0,
    "url": "https://github.com/gudavinay/273-Reddit",
    "diskUsage": 7594,
    "stargazerCount": 6,
    "primaryLanguage": {
      "name": "JavaScript",
      "color": "#f1e05a",
      "__typename": "Language"
    }
  },
  {
    "name": "Airline Reservation System",
    "description": "Airline Reservation System built with MERN Stack with hints of dynamic caching and load balancing.",
    "forkCount": 1,
    "url": "https://github.com/gudavinay/AirlineReservationSystem",
    "diskUsage": 5729,
    "stargazerCount": 2,
    "primaryLanguage": {
      "name": "JavaScript",
      "color": "#f1e05a",
      "__typename": "Language"
    },
  },
  {
    "name": "Vaccination Management System",
    "description": "Users can manage their vaccine dosages, book appointments in clinics with configurable dotors count, go in future simulation feature to check status of application.",
    "forkCount": 2,
    "url": "https://github.com/gudavinay/VaccinationManagementSystem",
    "diskUsage": 6729,
    "stargazerCount": 3,
    "primaryLanguage": {
      "name": "JavaScript",
      "color": "#f1e05a",
      "__typename": "Language"
    },
  },
  {
    "name": "Splitwise - with Kafka",
    "description": "Splitwise-replica with Node.js & Mongo DB for backend, React.js for frontend and additional features like redux, jwt, passport, kafka.",
    "forkCount": 0,
    "url": "https://github.com/gudavinay/splitwise",
    "diskUsage": 4683,
    "stargazerCount": 2,
    "primaryLanguage": {
      "name": "JavaScript",
      "color": "#f1e05a",
      "__typename": "Language"
    },
    "video": "https://youtu.be/ZAYMnkXQqXY"
  },
  {
    "name": "Sorting Visualizer",
    "description": "Tool to visualize different sorting techniques in real-time. (Bubble, Merge, Heap, Selection Sort).",
    "forkCount": 0,
    "url": "https://github.com/gudavinay/Sorting-Visualizer",
    "diskUsage": 692,
    "stargazerCount": 3,
    "primaryLanguage": {
      "name": "JavaScript",
      "color": "#f1e05a",
      "__typename": "Language"
    },
    "demo": "/sortingVisualizer"
  },
  {
    "name": "BAND",
    "description": "A playlist curating Android application based on the similarity of taste in music. (uses Apple Music & Youtube’s music collection)",
    "forkCount": 7,
    "url": "https://youtu.be/UwxULWFOqYk",
    "diskUsage": 8934,
    "stargazerCount": 1,
    "primaryLanguage": {
      "name": "Java",
      "color": "#b07219",
      "__typename": "Language"
    },
    "video": "https://youtu.be/UwxULWFOqYk"
  },
  {
    "name": "Walmart Sales Prediction",
    "description": "Aimed to predict the sales of Walmart using past data with 4 different machine learning models (KNN, DT, XGB and RFA)",
    "forkCount": 0,
    "url": "https://github.com/gudavinay/Walmart-Sales-Prediction",
    "diskUsage": 195220,
    "stargazerCount": 0,
    "primaryLanguage": {
      "name": "Jupyter Notebook",
      "color": "#DA5B0B",
      "__typename": "Language"
    },
  },
  {
    "name": "Smart Cop",
    "description": "A mobile application for the Police Commissionerate of the Telangana State that allows the citizens to report the traffic offence along with a snapshot instantly.",
    "forkCount": 0,
    "url": "https://drive.google.com/drive/folders/0B7EuRhvgsxSdeS1TWDdHaGVOM28?usp=sharing",
    "diskUsage": 3092,
    "stargazerCount": 0,
    "primaryLanguage": {
      "name": "JAVA",
      "color": "#b07219",
      "__typename": "Language"
    },
  },
  {
    "name": "Big Data: Document Indexing study",
    "description": "Using the MapReduce programming paradigm and Hadoop Framework, Inverted Indexing and Hash-based indexing have been analysed and compared",
    "forkCount": 0,
    // "url": "https://drive.google.com/drive/folders/0B7EuRhvgsxSdeS1TWDdHaGVOM28?usp=sharing",
    "diskUsage": 23890,
    "stargazerCount": 0,
    "primaryLanguage": {
      "name": "JAVA",
      "color": "#b07219",
      "__typename": "Language"
    },
  }
];


// Your Achievement Section Include Your Certification Talks and More

const achievementSection = {
  title: "Certifications",
  // subtitle:"",
  achivementsCards: [
    {
      title: "Oracle PL/SQL Developer Certified Associate.",
      subtitle: "Demonstrated expertise in building database-centric Internet applications for Oracle Database 10g, 11g and 12c.",
      image: require("./assets/images/plsql.png"),
      footerLink: [
        { name: "Certification", url: "https://www.credly.com/badges/493f4d9e-c027-48d6-afbe-59e18a49670f" },
      ]
    },
    {
      title: "Technology Entrepreneurship Program, the Indian School of Business (2016 - 2018).",
      subtitle: "To foster an entrepreneurial mindset in engineering students; and mentor and support students.",
      image: require("./assets/images/isbtep.png"),
      footerLink: [
        // { name: "Certification", url: "https://www.credly.com/badges/493f4d9e-c027-48d6-afbe-59e18a49670f" },
      ]
    },
  ]
};

const contactInfo = {
  title: "Contact Me ✉️",
  subtitle: "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+1 (408) 275 5657",
  email_address: "vinayguda05@gmail.com"
};


const education = [
  {
    degree: "Masters of Science, Software Engineering",
    year: "Jan 2021-Dec 2022",
    college: "San Jose State University",
    description: "Course work : Enterprise Distributed Systems, Enterprise Software Platforms, Data Mining, Enterprise Application Development, Software Design Principles"
  },
  {
    degree: "Bachelors of Technology, Computer Science and Engineering",
    year: "2014-2018",
    college: "Jawaharlal Nehru Technological University",
    description: "Course work : Operating Systems, Data Structures & Algorithms, Computer Networks, Object Oriented Programming"
  }
];

const blogsHeading = {
  title: "Blogs",
  subtitle: "Authored by Vinay Guda.",
}

const blogs = [
  {
    title: "TITLEELRLELRLRE",
    subtitle: "ST Jan 2021-Dec 2022",
    author: "author",
    dateCreated: "Date created",
    description: `# Coming Soon

    ### Stay tuned for updates
    
    I am currently working hard to bring you something amazing. Check back soon for more information and updates. 
    Thank you for your patience! ♥️
    `
  },
];

export { greeting, socialMediaLinks, skillsSection, workExperiences, githubProjects, achievementSection, contactInfo, education, blogs, blogsHeading };
